import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Avatar,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import { RootState, AppDispatch } from '../../store';
import { logout } from '../../store/slices/authSlice';

const drawerWidth = 220;

interface NavbarProps {
  onDrawerToggle: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onDrawerToggle }) => {
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'white',
        color: 'text.primary',
        boxShadow: '0 2px 4px -1px rgba(0,0,0,0.12)',
        height: { xs: 48, sm: 64 },
        minHeight: { xs: 48, sm: 64 },
        justifyContent: 'center'
      }}
    >
      <Toolbar sx={{ px: { xs: 1, sm: 2 }, minHeight: { xs: 48, sm: 64 }, height: { xs: 48, sm: 64 } }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onDrawerToggle}
          sx={{ mr: 1, display: { md: 'none' }, p: { xs: 0.5, sm: 1 } }}
        >
          <MenuIcon />
        </IconButton>
        
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
            <img src="/logo.png" alt="Steam Genie Logo" style={{ height: '36px', marginRight: 6 }} />
        </Box>

        {user && (
          <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: { xs: 'row', sm: 'row' }, gap: { xs: 0.5, sm: 1.5 }, minWidth: { xs: 0, sm: 220 }, maxWidth: { xs: '100%', sm: 400 } }}>
            <AccountCircle sx={{ mr: 0.5, fontSize: { xs: 22, sm: 28 } }} />
            <Typography variant="body2" sx={{ fontSize: { xs: '0.85rem', sm: '1rem' }, textAlign: 'left', fontWeight: 500, maxWidth: { xs: 90, sm: 200 }, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user.firstName} {user.lastName}
            </Typography>
            {isMobile ? (
              <IconButton color="inherit" onClick={handleLogout} sx={{ ml: 0.5, p: 0.5 }}>
                <LogoutIcon />
              </IconButton>
            ) : (
              <Button color="inherit" onClick={handleLogout} sx={{ ml: 2, textTransform: 'none' }}>
                Cerrar Sesión
              </Button>
            )}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 